import { createSelector } from '@reduxjs/toolkit';
import selectCommonRaw from './selectCommonRaw';

export default createSelector(selectCommonRaw, (common) => common.online - common.offline);
